import { capitalize } from 'vue';

import i18n from '@/vueI18n';

export default function allUVs() {
  return [
    { id: 'LOW', name: capitalize(i18n.global.t('options.uv.low')), color: '#66DB80' },
    { id: 'MODERATE', name: capitalize(i18n.global.t('options.uv.moderate')), color: '#F6DE50' },
    { id: 'HIGH', name: capitalize(i18n.global.t('options.uv.high')), color: '#E43751' },
    { id: 'VERY HIGH', name: capitalize(i18n.global.t('options.uv.veryHigh')), color: '#9F1FEC' },
  ];
}

// { label: 'Low', value: 'low', color: '#66DB80' },
// { label: 'Medium', value: 'medium', color: '#F6DE50' },
// { label: 'High', value: 'high', color: '#F09C39' },
// { label: 'Very high', value: 'very-high', color: '#E43751' },
// { label: 'Extreme', value: 'extreme', color: '#9F1FEC' },
